import { useTranslation } from "react-i18next"
import { DotPill, Tone } from "../../delivery/atoms"

const TONES: Record<string, Tone> = {
  DRAFT: "grey",
  APPROVED: "blue",
  DISPATCHED_PICKUP: "amber",
  PICKUP_COMPLETED: "amber",
  IN_TRANSIT: "blue",
  AT_DESTINATION: "blue",
  RECEIVED: "green",
  CANCELLED: "red",
}

/** Inbound order status: coloured dot + dark text. */
export function InboundStatusBadge({ status }: Readonly<{ status: string | null | undefined }>) {
  const { t } = useTranslation("inbound")
  if (!status) return <>-</>
  return <DotPill tone={TONES[status] ?? "grey"}>{t(`status.${status}`, { defaultValue: "-" })}</DotPill>
}
